module.exports = __webpack_public_path__ + "static/img/brick-wall.d9c28d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brick-wall.jpg
// module id = wGX2
// module chunks = 0